module.exports = __webpack_public_path__ + "static/img/2.8b73d7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/2.png
// module id = wJs9
// module chunks = 0